// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section[data-v-6eae35a7]{margin-bottom:30px}", ""]);
// Exports
module.exports = exports;
